// extracted by mini-css-extract-plugin
export default {"box":"Know_box__+7CyB","boxDesc":"Know_boxDesc__bph+u","grid":"Know_grid__VYHCm","headingdiv":"Know_headingdiv__mdttP","heading":"Know_heading__WMlyd","sub":"Know_sub__Lvz8B"};